/**
 * Identify Debt Types — subsection 2 (/sframe-199-s2)
 */

import { useParams } from 'react-router-dom';
import DebtReviewSectionShell, { type ChecklistItemDef } from './DebtReviewSectionShell';

const ITEMS: ChecklistItemDef[] = [
  {
    id: 'types-1',
    title: 'Categorize Liabilities',
    description: 'Label each debt as secured, administrative, tax, or unsecured.',
  },
  {
    id: 'types-2',
    title: 'Identify Priority Debts',
    description: 'Flag debts that must be paid before others per state law.',
  },
  {
    id: 'types-3',
    title: 'Review Joint Accounts',
    description: 'Identify any accounts with co-signers or joint holders.',
  },
];

export default function ReviewOrganize_IdentifyTypes() {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <DebtReviewSectionShell
      estateId={estateId}
      title="Identify Debt Types"
      sectionIndex={2}
      checklistFrameId="sframe-199-s2"
      hubSectionKey="s2"
      items={ITEMS}
    />
  );
}
